if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const rate = Shopify.currency.rate || 1;
      const total = parseInt(this.dataset.cartTotal, 10);
      const lang = document.documentElement.lang || 'en';

      let format = "{{amount_no_decimals_with_comma_separator}} VND" || "${{amount}}";
      if (lang === 'vi') {
        format = format.replace('VND', 'Đ');
      }

      const tiers = Array.from(this.querySelectorAll('.free-shipping--text-remaining'))
        .map((el) => ({
          el: el,
          amount: Math.round(parseInt(el.dataset.tierAmount, 10) * rate)
        }))
        .filter((tier) => tier.amount > 0)
        .sort((a, b) => a.amount - b.amount);

      if (!tiers.length) {
        return;
      }

      const fullText = this.querySelector('.free-shipping--text-full');
      const maxAmount = tiers[tiers.length - 1].amount;
      const nextTier = tiers.find((tier) => total < tier.amount);
      const percentage = Math.min(total / maxAmount, 1);

      tiers.forEach((tier) => {
        tier.el.style.display = 'none';
      });
      if (fullText) {
        fullText.style.display = 'none';
      }

      if (nextTier) {
        const amountText = nextTier.el.querySelector('span');
        if (amountText) {
          amountText.innerHTML = formatMoney(nextTier.amount - total, format);
        }
        nextTier.el.style.display = 'block';
      } else if (fullText) {
        fullText.style.display = 'block';
      }

      this.querySelectorAll('.free-shipping--milestone').forEach((milestone) => {
        const amount = Math.round(parseInt(milestone.dataset.tierAmount, 10) * rate);
        milestone.classList.toggle('is-unlocked', total >= amount);
      });

      const bar = this.querySelector('.free-shipping--bar');
      if (bar) {
        bar.setAttribute('aria-valuenow', Math.round(percentage * 100));
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
